import type { HugeiconsProps } from '@hugeicons/react-native';
import type { BottomTabBarButtonProps } from 'expo-router/js-tabs';
import React from 'react';
import { Pressable } from 'react-native';

export interface ITabBarSlideMenuButtonItem<T extends string> {
  value: T;
  label: string;
  icon?: HugeiconsProps['icon'];
  solidIcon?: HugeiconsProps['icon'];
  separatorBefore?: boolean;
  sectionTitleBefore?: string;
}

interface ITabBarSlideMenuButtonProps<T extends string> {
  buttonProps: BottomTabBarButtonProps;
  items: ITabBarSlideMenuButtonItem<T>[];
  value?: T | null;
  tabName?: string;
  onColdTabSelect?: (value: T) => void;
  onSelect: (value: T) => void;
}

// The slide menu's warm-tab handoff is native-only (web renders a plain
// Pressable), but the tab layout imports this unconditionally — keep the
// no-op stub. (The mount registry itself lives in tabMountRegistry, which is
// platform-neutral and imported directly.)
export function runPendingTabSelection(_tabName: string | undefined) {}

export function TabBarSlideMenuButton<T extends string>({
  buttonProps,
}: ITabBarSlideMenuButtonProps<T>) {
  return (
    <Pressable
      accessibilityLabel={buttonProps.accessibilityLabel}
      accessibilityRole={buttonProps.accessibilityRole}
      accessibilityState={buttonProps.accessibilityState}
      testID={buttonProps.testID}
      style={buttonProps.style}
      onPress={buttonProps.onPress}>
      {buttonProps.children}
    </Pressable>
  );
}
